import {
  Table,
  Input,
  Button,
  Divider,
  DatePicker,
  Row,
  Col,
  Popover,
} from 'antd/lib';
const { RangePicker } = DatePicker;
import * as Icons from '@ant-design/icons';

import React from 'react';
import moment from 'moment';

class TablaDeclaracionesJuradas extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filterDropdownVisible: false,
      verFiltroApellido: false,
      data: this.props.certificaciones,
      textoBuscarNombre: props.textoFiltroNombre ? props.textoFiltroNombre : '',
      textoBuscarApellido: props.textoFiltroApellido
        ? props.textoFiltroApellido
        : '',
      textoBuscarDocumento: props.textoFiltroDocumento
        ? props.textoFiltroDocumento
        : '',
      filtered: false,
    };
  }

  onInputChange = e => {
    this.setState({ textoBuscarNombre: e.target.value });
  };

  onApellidoChange = e => {
    this.setState({ textoBuscarApellido: e.target.value });
  };

  onDocumentoChange = e => {
    this.setState({ textoBuscarDocumento: e.target.value });
  };

  descargar = () => {
    this.props.onDescargar();
  };

  render() {
    const columns = [
      {
        title: 'Tipo Doc',
        dataIndex: ['declarante', 'tipo_doc'],
        key: 'tipo_doc',
      },
      {
        title: 'Num Doc',
        dataIndex: ['declarante', 'num_doc'],
        key: 'num_doc',
        filterDropdown: (
          <div className="custom-filter-dropdown">
            <Input
              ref={ele => (this.searchInput = ele)}
              placeholder="Buscar documento"
              value={this.state.textoBuscarDocumento}
              onChange={this.onDocumentoChange}
              onPressEnter={() =>
                this.props.filtrarPorDocumento(this.state.textoBuscarDocumento)
              }
            />
            <Button
              type="primary"
              onClick={() =>
                this.props.filtrarPorDocumento(this.state.textoBuscarDocumento)
              }
            >
              Buscar Documento
            </Button>
          </div>
        ),
        filterIcon: (
          <Icons.FilterOutlined
            style={{
              color:
                this.state.textoBuscarDocumento &&
                this.state.textoBuscarDocumento.length > 0
                  ? '#108ee9'
                  : '#aaa',
            }}
          />
        ),
        filterDropdownVisible: this.state.verFiltroDocumento,
        onFilterDropdownVisibleChange: visible => {
          this.setState(
            {
              verFiltroDocumento: visible,
            },
            () => this.searchInput && this.searchInput.focus()
          );
        },
      },
      {
        title: 'Nombre',
        dataIndex: ['declarante', 'nombre'],
        key: 'nombre',
        filterDropdown: (
          <div className="custom-filter-dropdown">
            <Input
              ref={ele => (this.searchInput = ele)}
              placeholder="Buscar nombre"
              value={this.state.textoBuscarNombre}
              onChange={this.onInputChange}
              onPressEnter={() =>
                this.props.filtrarPorNombre(this.state.textoBuscarNombre)
              }
            />
            <Button
              type="primary"
              onClick={() =>
                this.props.filtrarPorNombre(this.state.textoBuscarNombre)
              }
            >
              Buscar Nombre
            </Button>
          </div>
        ),
        filterIcon: (
          <Icons.FilterOutlined
            style={{
              color:
                this.state.textoBuscarDocumento &&
                this.state.textoBuscarDocumento.length > 0
                  ? '#108ee9'
                  : '#aaa',
            }}
          />
        ),
        filterDropdownVisible: this.state.filterDropdownVisible,
        onFilterDropdownVisibleChange: visible => {
          this.setState(
            {
              filterDropdownVisible: visible,
            },
            () => this.searchInput && this.searchInput.focus()
          );
        },
      },
      {
        title: 'Apellido',
        dataIndex: ['declarante', 'apellido'],
        key: 'apellido',
        filterDropdown: (
          <div className="custom-filter-dropdown">
            <Input
              ref={ele => (this.searchInput = ele)}
              placeholder="Buscar Apellido"
              value={this.state.textoBuscarApellido}
              onChange={this.onApellidoChange}
              onPressEnter={() =>
                this.props.filtrarPorApellido(this.state.textoBuscarApellido)
              }
            />
            <Button
              type="primary"
              onClick={() =>
                this.props.filtrarPorApellido(this.state.textoBuscarApellido)
              }
            >
              Buscar Apellido
            </Button>
          </div>
        ),
        filterIcon: (
          <Icons.FilterOutlined
            style={{
              color:
                this.state.textoBuscarApellido &&
                this.state.textoBuscarApellido.length > 0
                  ? '#108ee9'
                  : '#aaa',
            }}
          />
        ),
        filterDropdownVisible: this.state.verFiltroApellido,
        onFilterDropdownVisibleChange: visible => {
          this.setState(
            {
              verFiltroApellido: visible,
            },
            () => this.searchInput && this.searchInput.focus()
          );
        },
      },
      {
        title: 'Fecha',
        dataIndex: 'fecha_creacion',
        key: 'fecha_creacion',
        render: fecha => moment(fecha).format('DD/MM/YYYY'),
      },
      {
        title: 'Venta',
        dataIndex: 'venta',
        key: 'venta',
        align: 'center',
        render: venta =>
          venta && (venta._id || venta.id) ? (
            venta.datosPosnet ? (
              <Popover
                content={
                  <div>
                    <Row>Importe: ${venta.importe}</Row>
                    <Row>Numero: {venta.numero ? venta.numero : venta.id}</Row>
                    <Row>
                      Codigo Operacion: {venta.datosPosnet.codigoOperacion}
                    </Row>
                    <Row>Numero Ticket: {venta.datosPosnet.numeroTicket}</Row>
                  </div>
                }
                title={`Datos de la Transaccion`}
              >
                <Icons.DollarOutlined
                  style={{ fontSize: '24px', color: '#0000FF' }}
                />
              </Popover>
            ) : venta.tipoPago === 'Mercado Pago' ? (
              <Popover
                content={
                  <div>
                    <Row>Importe: ${venta.importe}</Row>
                    <Row>Numero: {venta.numero ? venta.numero : venta.id}</Row>
                    <Row>
                      Numero Comprobante:{' '}
                      {venta.datosMercadoPago
                        ? venta.datosMercadoPago.numeroComprobante
                        : '-'}
                    </Row>
                  </div>
                }
                title={`Datos de la Transaccion`}
              >
                <Icons.DollarOutlined
                  style={{ fontSize: '24px', color: '#00b4d8' }}
                />
              </Popover>
            ) : (
              <Popover
                content={
                  <div>
                    <Row>Importe: ${venta.importe}</Row>
                    <Row>Numero: {venta.numero ? venta.numero : venta.id}</Row>
                  </div>
                }
                title={`Datos de la Transaccion`}
              >
                <Icons.DollarCircleOutlined
                  style={{ fontSize: '24px', color: '#00FF00' }}
                />
              </Popover>
            )
          ) : (
            <Icons.DollarOutlined
              style={{ fontSize: '24px', color: '#878a88' }}
            />
          ),
      },
      {
        title: 'Usuario',
        dataIndex: 'creador',
        key: 'creador',
        render: creador => (creador ? creador.apellido.toUpperCase() : '-'),
      },
      {
        title: 'Acciones',
        key: 'acciones',
        render: (text, record) => (
          <span>
            <Button
              size="small"
              // type="primary"
              icon={<Icons.PrinterOutlined />}
              disabled={!record.modelo_nota}
              onClick={() => this.props.imprimir(record)}
            >
              Imprimir
            </Button>
            <Divider type="vertical" />
            {record.venta && (
              <>
                <Button
                  size="small"
                  type="primary"
                  icon={<Icons.FilePdfOutlined />}
                  onClick={() =>
                    this.props.generarRecibo(record.venta.recibo64)
                  }
                >
                  Recibo Venta
                </Button>
                <Divider type="vertical" />
              </>
            )}
            <Button
              size="small"
              type="primary"
              disabled={!record.modelo_nota}
              icon={<Icons.EditOutlined />}
              onClick={() =>
                this.props.history.push(`/admin/declaraciones/${record._id}`)
              }
            >
              Editar
            </Button>
            <Divider type="vertical" />
            <Button
              size="small"
              type="danger"
              icon={<Icons.DeleteOutlined />}
              disabled={
                !this.props.usuario ||
                (this.props.usuario.rol !== 'SUPERVISOR' &&
                  this.props.usuario.rol !== 'FUNCIONARIO')
              }
              onClick={() => this.props.onDelete(record._id)}
            >
              Eliminar
            </Button>
          </span>
        ),
      },
    ];
    const { declaraciones } = this.props;

    const paginationOptions = {
      onChange: page => {
        this.props.cambiarPagina(page);
      },
      total: this.props.total,
      current: this.props.pagina,
      pageSize: this.props.cantidadPorPagina,
      pageSizeOptions: ['2', '5', '10', '20', '50'],
      showSizeChanger: true,
      showQuickJumper: true,
      onShowSizeChange: (current, pageSize) => {
        this.props.cambiarTamañoPagina(pageSize);
        this.props.cambiarPagina(1);
      },
    };

    return (
      <Table
        rowKey="_id"
        columns={columns}
        pagination={paginationOptions}
        dataSource={declaraciones}
        loading={this.props.loadingTabla}
        title={() => (
          <div>
            <h2 style={{ textAlign: 'center' }}> Declaraciones Juradas </h2>
            <div style={{ textAlign: 'center' }}>
              <Row>
                <Col span={6}>
                  Cantidad Total de Declaraciones: {this.props.total}
                </Col>
                <Col span={12}>
                  <RangePicker
                    onChange={this.props.onChange}
                    defaultValue={
                      this.props.fechaInicio && this.props.fechaFin
                        ? [
                            moment(this.props.fechaInicio),
                            moment(this.props.fechaFin),
                          ]
                        : [moment().subtract(7, 'd'), moment()]
                    }
                    format={'DD-MM-YYYY'}
                  />
                </Col>
                <Col span={6}>
                  <Button type="primary" onClick={this.descargar}>
                    <Icons.DownloadOutlined />
                    Descargar Reporte
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
        )}
        locale={{
          emptyText: 'Sin declaraciones juradas cargadas.',
        }}
      />
    );
  }
}

export default TablaDeclaracionesJuradas;
